import React from 'react';
import {
  Column,
  Heading,
  Image,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { GroceriesHowItWorksStep } from 'src/components/enterprise/features/Groceries/components/GroceriesHowItWorks/GroceriesHowItWorksStep';
import { GROCERIES_HOW_IT_WORKS_IMAGE_URL } from 'src/components/enterprise/features/Groceries/constants/groceriesAssets';
import { GroceriesContent } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

interface GroceriesHowItWorksProps {
  groceriesContent: GroceriesContent;
}

export function GroceriesHowItWorks({
  groceriesContent,
}: GroceriesHowItWorksProps): JSX.Element {
  return (
    <PageSection variant="rounded">
      <Row alignItems="center">
        <Column phone={12} tablet={12} desktop={5}>
          <Stack x="xxx-lg">
            <Image
              src={GROCERIES_HOW_IT_WORKS_IMAGE_URL}
              alt=""
              role="presentation"
            />
          </Stack>
        </Column>
        <Column phone={12} tablet={12} desktop={7}>
          <Stack y="md">
            <Heading variant="h1">{groceriesContent.howItWorks.title}</Heading>
          </Stack>
          {groceriesContent.howItWorks.steps.map((step) => (
            <Stack y="lg" key={step.number}>
              <GroceriesHowItWorksStep step={step} />
            </Stack>
          ))}
        </Column>
      </Row>
    </PageSection>
  );
}
